import { useEffect, useState } from 'react'
import { useMap } from '@vis.gl/react-google-maps'

type HexColor = `#${string}`

export type DrawStylePalette = {
  activeFeatureZIndex: number
  fillColor: HexColor
  fillOpacity: number
  midpointSize: number
  outlineColor: HexColor
  outlineWidth: number
  passiveFeatureZIndex: number
  pointFillColor: HexColor
  pointOutlineColor: HexColor
  pointOutlineWidth: number
  pointSize: number
}

const LIGHT_DRAW_STYLES: DrawStylePalette = {
  activeFeatureZIndex: 20,
  fillColor: '#2563eb',
  fillOpacity: 0.12,
  midpointSize: 4.5,
  outlineColor: '#2563eb',
  outlineWidth: 1,
  passiveFeatureZIndex: 1,
  pointFillColor: '#ffffff',
  pointOutlineColor: '#2563eb',
  pointOutlineWidth: 1,
  pointSize: 6,
}

const HYBRID_DRAW_STYLES: DrawStylePalette = {
  activeFeatureZIndex: 20,
  fillColor: '#60a5fa',
  fillOpacity: 0.16,
  midpointSize: 5,
  outlineColor: '#60a5fa',
  outlineWidth: 3,
  passiveFeatureZIndex: 1,
  pointFillColor: '#ffffff',
  pointOutlineColor: '#60a5fa',
  pointOutlineWidth: 2,
  pointSize: 8,
}

export function useDrawStyleTokens() {
  const map = useMap()
  const [isHybrid, setIsHybrid] = useState(
    () => map?.getMapTypeId() === 'hybrid'
  )

  useEffect(() => {
    if (!map) return

    const sync = () => {
      setIsHybrid(map.getMapTypeId() === 'hybrid')
    }

    sync()

    const listener = map.addListener('maptypeid_changed', sync)

    return () => {
      listener.remove()
    }
  }, [map])

  return isHybrid ? HYBRID_DRAW_STYLES : LIGHT_DRAW_STYLES
}
